<template>
  <div class="creative-preview">
    <div class="title-section">
      <p class="preview-title">创意预览</p>
      <div class="change-arrow">
        <i class="el-icon-back icon mr"></i>
        <i class="el-icon-right icon"></i>
      </div>
    </div>
    <div class="change-apps">
      <div
        class="tab-item"
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ active: currentApp == tab.name }"
        @click="currentApp = tab.name"
      >
        <el-tooltip :content="tab.name" placement="top">
          <el-image
            style="width: 32px; height: 32px"
            :src="tab.icon"
            fit="contain"
          ></el-image>
        </el-tooltip>
      </div>
    </div>
    <div class="change-style" v-if="currentApp == '抖音'">
      <el-select v-model="changeStyle" size="mini" placeholder="请选择">
        <el-option label="商品推广卡样式" value="商品推广卡样式"></el-option>
        <el-option label="购物车锚点样式" value="购物车锚点样式"> </el-option>
      </el-select>
    </div>
    <div class="component-preview-wrapper">
      <div class="preview-video" v-if="haveVideo && currentApp != '西瓜'">
        <el-image
          style="width: 264px; height: 468px"
          :src="require(`@/assets/images/simulation/preview_${imgName}.png`)"
          fit="cover"
        ></el-image>
      </div>
      <div class="not-support" v-else>
        <el-image
          style="width: 100px; height: 72px"
          :src="require('@/assets/images/simulation/empty.png')"
          fit="cover"
        ></el-image>
        <p class="empty-text">该广告位暂不支持该创意类型</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    haveVideo: Boolean,
  },
  data() {
    return {
      tabs: [
        {
          name: "抖音",
          icon: require("@/assets/images/simulation/icon_douyin.png"),
        },
        {
          name: "头条",
          icon: require("@/assets/images/simulation/icon_toutiao.png"),
        },
        {
          name: "西瓜",
          icon: require("@/assets/images/simulation/icon_xigua.png"),
        },
        {
          name: "抖音火山版",
          icon: require("@/assets/images/simulation/icon_huoshan.png"),
        },
        {
          name: "穿山甲",
          icon: require("@/assets/images/simulation/icon_chuanshanjia.png"),
        },
      ],
      currentApp: "抖音",
      changeStyle: "商品推广卡样式",
    };
  },
  computed: {
    imgName() {
      if (this.currentApp == "抖音" && this.changeStyle == "商品推广卡样式")
        return "dy1";
      else if (
        this.currentApp == "抖音" &&
        this.changeStyle == "购物车锚点样式"
      )
        return "dy2";
      else if (this.currentApp == "头条") return "tt";
      else if (this.currentApp == "抖音火山版") return "hs";
      else if (this.currentApp == "穿山甲") return "csj";
    },
  },
};
</script>
<style lang="less" scoped>
.creative-preview {
  width: 310px;
  padding: 24px;
  background-color: #fff;
  border: 1px solid #e3e3e4;
  border-radius: 2px;
  .title-section {
    overflow: hidden;
    .preview-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #1f1f1f;
      display: inline-block;
      margin-bottom: 21px;
    }
    .change-arrow {
      float: right;
      .icon {
        font-size: 20px;
        font-weight: bold;
        color: #999;
        cursor: not-allowed;
        &.mr {
          margin-right: 27px;
        }
      }
    }
  }
  .change-apps {
    margin-bottom: 15px;
    .tab-item {
      display: inline-block;
      opacity: 0.5;
      cursor: pointer;
      &.active {
        opacity: 1;
      }
      &:not(:first-child) {
        margin-left: 24px;
      }
    }
  }
  ::v-deep .change-style {
    margin-bottom: 15px;
    width: 160px;
    .el-input__inner {
      background-color: #f2f2f2;
      border-color: #f2f2f2;
    }
  }

  .component-preview-wrapper {
    width: 264px;
    height: 468px;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    overflow: hidden;
    .not-support {
      padding-top: 160px;
      text-align: center;
      .empty-text {
        margin-top: 8px;
        font-size: 12px;
        line-height: 17px;
        color: #999;
      }
    }
  }
}
</style>